import React, { useMemo } from "react";
import { Provider } from "react-redux";
import reducer from "./redux/AIReducer";
import rootSaga from "./redux/AISagas";
import { createReduxStore } from "../../utils/createReduxStore";
import ErrorBoundary from "../../components/errorBoundary/errorBoundary";
import AIPage from "./ai-page";
import Widget from "./ai-widget";

const pageStore = createReduxStore(reducer, "ai", rootSaga);

const AIAgent = (props) => {
  const { notifications, widget, filter, objectId } = props;

  // Add object_id to URL if not present (needed for client profile links)
  if (objectId && objectId !== "-1" && !new URL(window.location.href).searchParams.has("object_id")) {
    const url = new URL(window.location.href);
    url.searchParams.set("object_id", objectId);
    window.history.replaceState(null, "", url.toString());
  }
  const store = useMemo(
    () => (widget ? createReduxStore(reducer, "ai", rootSaga) : pageStore),
    []
  );
  return (
    <Provider store={store}>
      <ErrorBoundary moduleName="ai-page" {...notifications}>
        {widget ? <Widget pageName={props.pageName} filter={filter} /> : <AIPage />}
      </ErrorBoundary>
    </Provider>
  );
};

export default AIAgent;
